import "./App.scss";
import "./Sass/Main.scss";
import Error404 from "./Error404";
import Error403 from "./Error403";
import constants from "./constants";
import Layout from "./Components/Layout";
import "bootstrap/dist/css/bootstrap.css";
import Company from "./Components/Company";
import "bootstrap/dist/js/bootstrap.bundle";
import Notify from "./Components/Notify/Notify";
import AlertContext from "./context/AlertContext";
import PushNotification from "./PushNotification";
import RequireAuth from "./Components/RequireAuth";
import Batch from "./Components/Admin/Batch/Batch";
import PresistLogin from "./Components/PresistLogin";
import Batches from "./Components/Admin/Batch/Batches";
import Courses from "./Components/Admin/Batch/Courses";
import LoginPage from "./Components/LoginPage/LoginPage";
import TestList from "./Components/Admin/Tests/TestList";
import Headers from "./Components/Student/Header/Header";
import BrowserSupport from "./Components/BrowserSupport";
import Interview from "./Components/Student/AI/Interview";
import Header from "./Components/CommonComponents/Header";
import { changeFavicon, getDataFromStorage } from "./util";
import Profile from "./Components/Student/Profile/Profile";
import { ProfileProvider } from "./context/ProfileContext";
import SQLPage from "./Components/Student/SQLPage/SQLPage";
import { LibraryProvider } from "./context/LibraryContext";
import Resume from "./Components/Admin/Batch/Users/Resume";
import JobForm from "./Components/JobPortal/Admin/JobForm";
import MenuBar from "./Components/Student/MenuBar/MenuBar";
import Report from "./Components/Admin/Batch/Report/Report";
import ZoomAdminView from "./Components/Zoom/ZoomAdminView";
import MainPage from "./Components/JobPortal/Users/MainPage";
import Content from "./Components/Student/Home/Content/Content";
import AdminHeader from "./Components/Admin/Header/AdminHeader";
import Dashboard from "./Components/CommonComponents/Dashboard";
import Clients from "./Components/Admin/Batch/Settings/Clients";
import UserTable from "./Components/Admin/Batch/Users/UserTable";
import MockTestPageProvider from "./context/MockTestPageContext";
import { UserReportProvider } from "./context/UserReportContext";
import CcHome from "./Components/Student/CodingChallenge/CcHome";
import ParentInfo from "./Components/Student/Profile/ParentInfo";
import Hackathons from "./Components/CommonComponents/Hackathons";
import Settings from "./Components/Admin/Batch/Settings/Settings";
import OldReport from "./Components/Admin/Batch/Report/OldReport";
import IssueTable from "./Components/Admin/Batch/issue/IssueTable";
import CodingPage from "./Components/Student/CodingPage/CodingPage";
import AcademicWork from "./Components/Student/Profile/AcademicWork";
import RegistrationPage from "./Components/Student/RegistrationPage";
import DoubtsTable from "./Components/Student/AskDoubts/DoubtsTable";
import Recommended from "./Components/Admin/Recommended/Recommended";
import RightMain from "./Components/Student/Home/RightMain/RightMain";
import EducationForm from "./Components/Student/Profile/EducationForm";
import React, { useState, useRef, useContext, useEffect } from "react";
import TestPage from "./Components/Student/Home/Mcq/TestPage/TestPage";
import StudentTestPageProvider from "./context/StudentTestPageContext";
import DashBoardForm from "./Components/Admin/Dashboard/DashBoardForm";
import LearningPath from "./Components/Student/DashBoard/LearningPath";
import InterviewLibrary from "./Components/Student/AI/InterviewLibrary";
import Loading from "./Components/Notification-Loading/Loading/Loading";
import Attendance from "./Components/Admin/Batch/Attendance/Attendance";
import LeftNavBar from "./Components/Student/Home/LeftNavBar/LeftNavBar";
import DashBoardTable from "./Components/Admin/Dashboard/DashBoardTable";
import AdminDashBoard from "./Components/Admin/Dashboard/AdminDashBoard";
import SocialProfiles from "./Components/Student/Profile/SocialProfiles";
import CompanyProfile from "./Components/Student/Profile/CompanyProfile";
import MobileView from "./Components/Student/InstructionPage/MobileView";
import ContentEntry from "./Components/Content/ContentEntry/ContentEntry";
import AssignmentForm from "./Components/Admin/Assignment/AssignmentForm";
import BatchDetails from "./Components/Admin/Batch/Settings/BatchDetails";
import SkillMapping from "./Components/Admin/Batch/Settings/SkillMapping";
import MockTestPage from "./Components/Student/MockTestPage/MockTestPage";
import SharedTopics from "./Components/Admin/QuestionReport/SharedTopics";
import RaisedIssueTable from "./Components/Student/Issue/RaisedIssueTable";
import UsersTableQueryProviders from "./Components/CommonComponents/Users";
import QuestionsEntry from "./Components/Admin/QuestionEntry/QuestionEntry";
import BatchTrainers from "./Components/Admin/Batch/Settings/BatchTrainers";
import PersonalInfoForm from "./Components/Student/Profile/PersonalInfoForm";
import MockTestList from "./Components/Admin/MockPage/MockTest/MockTestList";
import QuestionReport from "./Components/Admin/QuestionReport/QuestionReport";
import TableContent from "./Components/Admin/Batch/TableContent/Tablecontent";
import LibraryDetails from "./Components/Admin/QuestionReport/LibraryDetails";
import MockTestLibrary from "./Components/Student/MockTestPage/MockTestLibrary";
import MockTestResults from "./Components/Student/MockTestPage/MockTestResults";
import SandPackEditor from "./Components/Student/AssignmentPage/SandPackEditor";
import CcSecQuestions from "./Components/Student/CodingChallenge/CcSecQuestions";
import Attandaceonline from "./Components/Admin/Batch/Attendance/Attandaceonline";
import AdminLearningPath from "./Components/Admin/Learningpath/AdminLearningPath";
import MobileViewSetUp from "./Components/Student/InstructionPage/MobileViewSetUp";
import StudentTestPage from "./Components/Student/StudentTestPage/StudentTestPage";
import Attandaceoffline from "./Components/Admin/Batch/Attendance/Attandaceoffline";
import FloatingActionButton from "./Components/CommonComponents/FloatingActionButton";
import RecommendedTestPoints from "./Components/Admin/Recommended/RecommendedTestPoints";
import SandpackReactEditor from "./Components/Student/AssignmentPage/SandpackReactEditor";
import CreateSession from "./Components/Admin/Batch/Attendance/CreateSession/CreateSession";
import MockLearningPath from "./Components/Admin/MockPage/MockLearningPath/MockLearningPath";
import MobileViewInstruction from "./Components/Student/InstructionPage/MobileViewInstruction";
import UserTimeSpentReport from "./Components/UserReport/UserTimeSpentReport/UserTimeSpentReport";
import MockLearningPathList from "./Components/Admin/MockPage/MockLearningPath/MockLearningPathList";
import AttendanceReport from "./Components/Admin/Batch/Attendance/AttendanceReport/AttendanceReport";
import UserTestResultReportTable from "./Components/UserReport/UserTestResultReport/UserTestResultReportTable";
import BatchDashboardReports from "./Components/Admin/Batch/DashboardReports/BatchDashboardReports";
import PublicProfilePage from "./Components/PublicProfile/PublicProfilePage";
import PublicProfileSectionPage from "./Components/PublicProfile/PublicProfileSectionPage";
import MainLayout from "./MainLayout";
import UniversitySettings from "./Components/CommonComponents/UniversitySettings";
// import StudentNoticeBoard from "./Components/Admin/Batch/Announcement/StudentsNoticeboard";
// import AnnouncementPost from "./Components/Admin/Batch/Announcement/AnnouncementPost";
import AdminNotices from "./Components/Admin/Batch/Announcement/AdminNotices";
import StudentNoticeBoard from "./Components/Admin/Batch/Announcement/StudentsNoticeboard";

import CompanySpecificLibrary from "./Components/Student/CompanySpecificPage/CompanySpecificLibrary";
import TechnologySpecificLibrary from "./Components/Student/TechnologySpecificPage/TechnologySpecificLibrary";
import CompanySpecificResults from "./Components/Student/MockTestPage/CompanySpecificResults";
import TechnologySpecificResults from "./Components/Student/MockTestPage/TechnologySpecificResults";
import UniversityDashboard from "./Components/Admin/Dashboard/UniversityDashboard/UniversityDashBoard";
import {
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";

import {
  isEdge,
  isSafari,
  isChrome,
  isFirefox,
  CustomView,
  browserName,
} from "react-device-detect";
import BatchDashboard from "./Components/Admin/Batch/BatchDashboard/BatchDashboard";
import { SOADashboard } from "./Components/Student/DashBoard/SOADashboard/SOADashboard";
import ReportPage from "./Components/Admin/Batch/Report/ReportPage";
import StudentsRemarks from "./Components/Admin/Batch/Users/StudentsRemarks/StudentsRemarks";
import CreateTest from "./Components/Admin/Tests/CreateTest";
import Path from "./Components/Admin/Learningpath/Path";
import ModuleDetails from "./Components/Admin/Learningpath/ModuleDetails";
import Module from "./Components/Admin/Learningpath/Module";
import Subjects from "./Components/Admin/QuestionReport/Subjects";
import QuestionList from "./Components/Admin/QuestionReport/QuestionList";
import AdminCcSection from "./Components/Admin/QuestionReport/AdminCcSection";
import AdminCcSectionQuestions from "./Components/Admin/QuestionReport/AdminCcSectionQuestions";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";


window.env = {
  token: localStorage.getItem("tokenKey"),
  REACT_APP_NODE_API: process.env.REACT_APP_NODE_API,
};

function App() {
  const {
    msg,
    lpId,
    show,
    title,
    libId,
    setMsg,
    status,
    setAuth,
    setLpId,
    setShow,
    setTitle,
    isLoaded,
    handleMcq,
    learnerId,
    setStatus,
    lpConfigId,
    handleClose,
    setIsLoaded,
    contentData,
    learnerNotes,
    isFullScreen,
    handleContent,
    isstableState,
    isAddSubmission,
    selectedQuestion,
    setIsStableState,
    LoadDeviceDetails,
    takeMcqAndDesTest,
    openSandpackEditor,
    notificationPayload,
    stablePageforBackbtn,
    stableTextforBackbtn,
    setOpenSandpackEditor,
    stableStateforBackbtn,
    setStablePageforBackbtn,
    setStableTextforBackbtn,
    setStableStateforBackbtn,

    //content

    selectque,
    isqueReport,
    setselectque,
    setisqueReport,
    selectedLibType,
    tableShowStatus,
    setTableShowStatus,
    openJobForm,
    setOpenJobForm,

    // content end
  } = useContext(AlertContext);

  let isAdmin;

  const getRole = () => {
    isAdmin = getDataFromStorage("role") === "learner" ? false : true;

    return isAdmin;
  };

  const isAuthenticated = () => !!localStorage.getItem("tokenKey");
  /* preview mode check */
  const isPreview =
    new URLSearchParams(window.location.search).get("mode") === "preview";
  const isPreviewLp =
    new URLSearchParams(window.location.search).get("mode") === "previewlp";

  isAdmin = getRole();

  let scrpos = useRef(0);

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const showFloatingActionBtn = false;

  let [performance, setperformance] = useState(false);

  const [report, setReport] = useState({});
  const [assignQnDetailsForLearner, setAssignQnDetailsForLearner] = useState(
    {},
  );

  const handleNavigate = () => {
    navigate("/main/landing");
  };

  useEffect(() => {
    setAuth({token:localStorage.getItem("tokenKey")});
    LoadDeviceDetails();
  }, []);

  // Here the Favicon is Override by the GradiousLogo
  useEffect(() => {
    if (pathname === "/") changeFavicon("/favicon.ico");
    else return;
  }, [pathname]);

  const quereport = (que) => {
    setselectque(que);
    let libtypeId = que.type;
    if (constants.MCQ_TYPES.includes(libtypeId))
      libtypeId = constants.libTypeIds.MCQ;
    else if (constants.DESC_TYPES.includes(libtypeId))
      libtypeId = constants.libTypeIds.DESCRIPTIVE;

    // if (libtypeId === constants.libTypeIds.ASSIGNMENT)
    //   navigate(`/library/${libtypeId}/assignment`);
    // else {
    //   navigate(`/library/${libtypeId}/questions`);
    //   console.log("this is navigation");
    // }
  };

  const querepor = (que) => {
    setselectque(que);
    let libtypeId = que.type;
    if (constants.MCQ_TYPES.includes(libtypeId))
      libtypeId = constants.libTypeIds.MCQ;
    else if (constants.DESC_TYPES.includes(libtypeId))
      libtypeId = constants.libTypeIds.DESCRIPTIVE;

    try {
      if (libtypeId === constants.libTypeIds.ASSIGNMENT)
        navigate(`/library/${libtypeId}/assignment`);
      else if (que.description === null) {
        navigate(`/library/${libtypeId}/questions`);
      } else if (typeof JSON.parse(que.description) === "object") {
        navigate(`/library/${libtypeId}/contententry`);
      } else {
        navigate(`/library/${libtypeId}/contententry`);
      }
    } catch (err) {
      navigate(`/library/${libtypeId}/questions`);
    }
  };

  const setscrpos = (val) => {
    scrpos.current = val;
  };

  const assignQuestionToLearner = (qnData) => {
    setAssignQnDetailsForLearner(qnData);
    navigate("/coding");
  };

  const disableRightClick = (e) => {
    if (!isAdmin) {
      e.preventDefault();
    }
  };

  return (
    <>
      <CustomView
        condition={
          !isChrome &&
          browserName !== "Electron" &&
          (isEdge || isSafari || isFirefox)
        }
      >
        <BrowserSupport />
      </CustomView>
      <CustomView
        condition={
          !isEdge &&
          !isSafari &&
          !isFirefox &&
          (isChrome || browserName === "Electron")
        }
      >
        <div
          onContextMenu={disableRightClick}
          className={isLoaded ? "appOnBlur" : "App"}
        >
          <Notify />
          {/* {isLoaded && <Loading />} */}
          {notificationPayload.open && <PushNotification />}

          {/* Header rendering is moved into MainLayout; App-level header rendering is removed to avoid duplicates */}

          <Routes>
            <Route element={<MainLayout />}>

              <Route
                path="/preview/home/:lpid/module/:mid"
                element={
                  <RequireAuth
                    allowedRoles={[
                      constants.Roles.admin,
                      constants.Roles.trainer,
                      constants.Roles.super_admin,
                      constants.Roles.learner,
                    ]}
                  >
                    <LeftNavBar />
                  </RequireAuth>
                }
              />

              <Route
                element={
                  <RequireAuth
                    allowedRoles={[
                      constants.Roles.admin,
                      constants.Roles.trainer,
                      constants.Roles.super_admin,
                      constants.Roles.learner,
                    ]}
                  />
                }
              >
                <Route path="/preview/home/:lpid/module" element={<MenuBar />}>
                  <Route path="learningpath" element={<LearningPath />} />
                </Route>
              </Route>

              <Route path="/" element={<Layout />}>
                <Route
                  path="/"
                  element={
                    <LoginPage
                      show={show}
                      setShow={setShow}
                      handleClose={handleClose}
                    />
                  }
                />

                {/* Public Profile Routes (No Auth Required). New format uses encoded id + hash + username. */}
                <Route path="/u/:idHash/:username" element={<PublicProfilePage />} />
                <Route path="/u/:idHash/:username/cc/section/:sname" element={<PublicProfileSectionPage />} />

                {/* Protected Routes */}

                <Route element={!pathname.includes("/dp") && <PresistLogin />}>
                  <Route
                  // element={
                  //   <RequireAuth
                  //     allowedRoles={[
                  //       constants.Roles.parent,
                  //       constants.Roles.learner,
                  //       constants.Roles.super_admin,
                  //       constants.Roles.trainer,
                  //       constants.Roles.tutor,
                  //       constants.Roles.hr,
                  //       constants.Roles.evaluator,
                  //       constants.Roles.creator,
                  //     ]}
                  //   />
                  // }
                  >
                    <Route path="/company" element={<Company />} />
                  </Route>
                  {[constants.Roles.tutor].includes(
                    getDataFromStorage("role"),
                  ) && (
                      <Route
                        element={
                          <RequireAuth allowedRoles={[constants.Roles.tutor]} />
                        }
                      >
                        <Route
                          path="/library"
                          element={
                            <LibraryProvider>
                              <LibraryDetails
                                que={tableShowStatus !== 1 ? quereport : querepor}
                                setisqueReport={setisqueReport}
                              />
                            </LibraryProvider>
                          }
                        >
                          <Route
                            index
                            path=":type/shared"
                            element={<Subjects isShared={true} />}
                          />
                          <Route
                            index
                            path=":type/subjects"
                            element={<Subjects />}
                          />
                          <Route
                            path=":type/questionlist"
                            element={
                              <QuestionList
                                isstableState={isstableState}
                                setisqueReport={setisqueReport}
                                selectedLibType={selectedLibType}
                                tableShowStatus={tableShowStatus}
                                setIsStableState={setIsStableState}
                                stablePageforBackbtn={stablePageforBackbtn}
                                stableTextforBackbtn={stableTextforBackbtn}
                                stableStateforBackbtn={stableStateforBackbtn}
                                setStableTextforBackbtn={setStableTextforBackbtn}
                                setStablePageforBackbtn={setStablePageforBackbtn}
                                que={tableShowStatus !== 1 ? quereport : querepor}
                                setStableStateforBackbtn={setStableStateforBackbtn}
                              />
                            }
                          />
                          <Route
                            path=":type/contententry"
                            element={
                              <ContentEntry
                                selectque={selectque}
                                quereport={quereport}
                                isqueReport={isqueReport}
                                setselectque={setselectque}
                                setisqueReport={setisqueReport}
                                tableShowStatus={tableShowStatus}
                                selectedLibType={selectedLibType}
                              />
                            }
                          />
                          <Route
                            path=":type/contententry/:libid"
                            element={
                              <ContentEntry
                                selectque={selectque}
                                quereport={quereport}
                                isqueReport={isqueReport}
                                setselectque={setselectque}
                                setisqueReport={setisqueReport}
                                tableShowStatus={tableShowStatus}
                                selectedLibType={selectedLibType}
                              />
                            }
                          />
                          <Route
                            path=":type/testlist"
                            element={
                              <TestList
                                setselectque={setselectque}
                                setTableShowStatus={setTableShowStatus}
                              />
                            }
                          />
                          <Route
                            path="mock/test"
                            element={
                              <MockTestList
                                setselectque={setselectque}
                                setTableShowStatus={setTableShowStatus}
                                mockuse={1}
                              />
                            }
                          />
                          <Route
                            path="mock/test/create"
                            element={
                              <CreateTest
                                setselectque={setselectque}
                                setTableShowStatus={setTableShowStatus}
                                mockuse={1}
                              />
                            }
                          />
                          <Route
                            path=":type/test/create"
                            element={<CreateTest />}
                          />
                          <Route
                            path=":type/test/:testid"
                            element={<CreateTest />}
                          />
                          <Route
                            path="mock/test/:testid"
                            element={<CreateTest mockuse={1} />}
                          />
                          <Route
                            path=":type/questions"
                            element={
                              <QuestionsEntry
                                msg={msg}
                                show={show}
                                title={title}
                                setMsg={setMsg}
                                setShow={setShow}
                                setTitle={setTitle}
                                isLoaded={isLoaded}
                                quereport={quereport}
                                selectque={selectque}
                                handleClose={handleClose}
                                isqueReport={isqueReport}
                                setIsLoaded={setIsLoaded}
                                setselectque={setselectque}
                                isstableState={isstableState}
                                setisqueReport={setisqueReport}
                                tableShowStatus={tableShowStatus}
                                selectedLibType={selectedLibType}
                                setIsStableState={setIsStableState}
                              />
                            }
                          >
                            <Route
                              path=":questionid"
                              element={
                                <QuestionsEntry
                                  msg={msg}
                                  show={show}
                                  title={title}
                                  setMsg={setMsg}
                                  setShow={setShow}
                                  setTitle={setTitle}
                                  isLoaded={isLoaded}
                                  quereport={quereport}
                                  selectque={selectque}
                                  handleClose={handleClose}
                                  isqueReport={isqueReport}
                                  setIsLoaded={setIsLoaded}
                                  setselectque={setselectque}
                                  isstableState={isstableState}
                                  setisqueReport={setisqueReport}
                                  tableShowStatus={tableShowStatus}
                                  selectedLibType={selectedLibType}
                                  setIsStableState={setIsStableState}
                                />
                              }
                            />
                          </Route>
                          <Route
                            path=":type/assignment"
                            element={
                              <AssignmentForm
                                selectque={selectque}
                                isqueReport={isqueReport}
                                setselectque={setselectque}
                                setisqueReport={setisqueReport}
                              />
                            }
                          >
                            <Route
                              path=":questionid"
                              element={
                                <AssignmentForm
                                  selectque={selectque}
                                  isqueReport={isqueReport}
                                  setselectque={setselectque}
                                  setisqueReport={setisqueReport}
                                />
                              }
                            />
                          </Route>
                        </Route>
                        <Route path="/batches" element={<Batches />} />
                        <Route path="/batches/:id/" element={<Batch />}>
                          {getDataFromStorage("role") !== constants.Roles.hr &&
                            getDataFromStorage("role") !==
                            constants.Roles.customer && (
                              <>
                                <Route
                                  element={<Settings />}
                                  path="/batches/:id/settings"
                                >
                                  <Route
                                    index
                                    path="details"
                                    element={<BatchDetails />}
                                  />
                                  <Route path="clients" element={<Clients />} />
                                  <Route
                                    path="skillmap"
                                    element={<SkillMapping />}
                                  />
                                  <Route
                                    path="trainers"
                                    element={<BatchTrainers />}
                                  />
                                </Route>
                                {/* <Route
                              path="/batches/:id/courses"
                              element={
                                <Courses
                                  quereport={querepor}
                                  setisqueReport={setisqueReport}
                                  setTableShowStatus={setTableShowStatus}
                                />
                              }
                            /> */}
                                <Route
                                  path="/batches/:id/courses/:lpid"
                                  element={<Path />}
                                />
                                <Route
                                  path="/batches/:id/courses/:lpid/module/:mid"
                                  element={<ModuleDetails />}
                                />
                                <Route
                                  element={<Attendance />}
                                  path="/batches/:id/event"
                                />
                                <Route
                                  element={<Attandaceonline />}
                                  path="/batches/:id/event/online"
                                />
                                <Route
                                  element={<Attandaceoffline />}
                                  path="/batches/:id/event/offline"
                                />
                                <Route
                                  element={<CreateSession />}
                                  path="/batches/:id/event/add"
                                />
                                <Route
                                  element={<AttendanceReport />}
                                  path="/batches/:id/event/record"
                                />
                                <Route
                                  element={<IssueTable />}
                                  path="/batches/:id/issue"
                                />
                              </>
                            )}

                          <Route
                            path="/batches/:id/timeline"
                            element={<TableContent />}
                          />

                          <Route
                            index
                            path="/batches/:id/users"
                            element={
                              <UserReportProvider>
                                <UserTable />
                              </UserReportProvider>
                            }
                          />
                          <Route
                            path="/batches/:id/report"
                            element={
                              <OldReport
                                lpid={lpId}
                                report={report}
                                scrpos={scrpos}
                                setLpId={setLpId}
                                navigate={navigate}
                                handleMcq={handleMcq}
                                setReport={setReport}
                                setStatus={setStatus}
                                setscrpos={setscrpos}
                                performance={performance}
                                setIsLoaded={setIsLoaded}
                                handleContent={handleContent}
                                setperformance={setperformance}
                                selectedQuestion={selectedQuestion}
                                assignQuestionToLearner={assignQuestionToLearner}
                              />
                            }
                          />

                          <Route
                            path="/batches/:id/path/:lpid/report"
                            element={
                              <UserReportProvider>
                                <ReportPage
                                  lpid={lpId}
                                  report={report}
                                  scrpos={scrpos}
                                  setLpId={setLpId}
                                  navigate={navigate}
                                  handleMcq={handleMcq}
                                  setReport={setReport}
                                  setStatus={setStatus}
                                  setscrpos={setscrpos}
                                  performance={performance}
                                  setIsLoaded={setIsLoaded}
                                  handleContent={handleContent}
                                  setperformance={setperformance}
                                  selectedQuestion={selectedQuestion}
                                  assignQuestionToLearner={assignQuestionToLearner}
                                />
                              </UserReportProvider>
                            }
                          />
                        </Route>
                      </Route>
                    )}
                  {getDataFromStorage("role") === constants.Roles.creator && (
                    <Route
                      element={
                        <RequireAuth allowedRoles={[constants.Roles.creator]} />
                      }
                    >
                      <Route
                        path="/library"
                        element={
                          <LibraryProvider>
                            <LibraryDetails
                              que={tableShowStatus !== 1 ? quereport : querepor}
                              setisqueReport={setisqueReport}
                            />
                          </LibraryProvider>
                        }
                      >
                        <Route
                          index
                          path=":type/shared"
                          element={<Subjects isShared={true} />}
                        />
                        <Route
                          index
                          path=":type/subjects"
                          element={<Subjects />}
                        />
                        <Route
                          path=":type/questionlist"
                          element={
                            <QuestionList
                              isstableState={isstableState}
                              setisqueReport={setisqueReport}
                              selectedLibType={selectedLibType}
                              tableShowStatus={tableShowStatus}
                              setIsStableState={setIsStableState}
                              stablePageforBackbtn={stablePageforBackbtn}
                              stableTextforBackbtn={stableTextforBackbtn}
                              stableStateforBackbtn={stableStateforBackbtn}
                              setStableTextforBackbtn={setStableTextforBackbtn}
                              setStablePageforBackbtn={setStablePageforBackbtn}
                              que={tableShowStatus !== 1 ? quereport : querepor}
                              setStableStateforBackbtn={setStableStateforBackbtn}
                            />
                          }
                        />
                      <Route
                        path=":type/cc/section"
                        element={
                          <AdminCcSection/>
                        }
                      />
                        <Route
                          path=":type/contententry"
                          element={
                            <ContentEntry
                              selectque={selectque}
                              quereport={quereport}
                              isqueReport={isqueReport}
                              setselectque={setselectque}
                              setisqueReport={setisqueReport}
                              tableShowStatus={tableShowStatus}
                              selectedLibType={selectedLibType}
                            />
                          }
                        />
                        <Route
                          path=":type/contententry/:libid"
                          element={
                            <ContentEntry
                              selectque={selectque}
                              quereport={quereport}
                              isqueReport={isqueReport}
                              setselectque={setselectque}
                              setisqueReport={setisqueReport}
                              tableShowStatus={tableShowStatus}
                              selectedLibType={selectedLibType}
                            />
                          }
                        />
                        <Route
                          path=":type/testlist"
                          element={
                            <TestList
                              setselectque={setselectque}
                              setTableShowStatus={setTableShowStatus}
                            />
                          }
                        />
                        <Route
                          path="mock/test"
                          element={
                            <MockTestList
                              setselectque={setselectque}
                              setTableShowStatus={setTableShowStatus}
                              mockuse={1}
                            />
                          }
                        />
                        <Route
                          path=":type/questions"
                          element={
                            <QuestionsEntry
                              msg={msg}
                              show={show}
                              title={title}
                              setMsg={setMsg}
                              setShow={setShow}
                              setTitle={setTitle}
                              isLoaded={isLoaded}
                              quereport={quereport}
                              selectque={selectque}
                              handleClose={handleClose}
                              isqueReport={isqueReport}
                              setIsLoaded={setIsLoaded}
                              setselectque={setselectque}
                              isstableState={isstableState}
                              setisqueReport={setisqueReport}
                              tableShowStatus={tableShowStatus}
                              selectedLibType={selectedLibType}
                              setIsStableState={setIsStableState}
                            />
                          }
                        >
                          <Route
                            path=":questionid"
                            element={
                              <QuestionsEntry
                                msg={msg}
                                show={show}
                                title={title}
                                setMsg={setMsg}
                                setShow={setShow}
                                setTitle={setTitle}
                                isLoaded={isLoaded}
                                quereport={quereport}
                                selectque={selectque}
                                handleClose={handleClose}
                                isqueReport={isqueReport}
                                setIsLoaded={setIsLoaded}
                                setselectque={setselectque}
                                isstableState={isstableState}
                                setisqueReport={setisqueReport}
                                tableShowStatus={tableShowStatus}
                                selectedLibType={selectedLibType}
                                setIsStableState={setIsStableState}
                              />
                            }
                          />
                        </Route>
                        <Route
                          path=":type/assignment"
                          element={
                            <AssignmentForm
                              selectque={selectque}
                              isqueReport={isqueReport}
                              setselectque={setselectque}
                              setisqueReport={setisqueReport}
                            />
                          }
                        >
                          <Route
                            path=":questionid"
                            element={
                              <AssignmentForm
                                selectque={selectque}
                                isqueReport={isqueReport}
                                setselectque={setselectque}
                                setisqueReport={setisqueReport}
                              />
                            }
                          />
                        </Route>
                      </Route>
                    </Route>
                  )}

                  {getDataFromStorage("role") === constants.Roles.evaluator && (
                    <Route
                      element={
                        <RequireAuth allowedRoles={[constants.Roles.evaluator]} />
                      }
                    >
                      <Route path="/batches" element={<Batches />} />
                      <Route path="/batches/:id/" element={<Batch />}>
                        <Route
                          index
                          path="/batches/:id/users"
                          element={
                            <UserReportProvider>
                              <UserTable />
                            </UserReportProvider>
                          }
                        />
                        <Route
                          path="/batches/:id/report"
                          element={
                            <OldReport
                              lpid={lpId}
                              report={report}
                              scrpos={scrpos}
                              setLpId={setLpId}
                              navigate={navigate}
                              handleMcq={handleMcq}
                              setReport={setReport}
                              setStatus={setStatus}
                              setscrpos={setscrpos}
                              performance={performance}
                              setIsLoaded={setIsLoaded}
                              handleContent={handleContent}
                              setperformance={setperformance}
                              selectedQuestion={selectedQuestion}
                              assignQuestionToLearner={assignQuestionToLearner}
                            />
                          }
                        />

                        <Route
                          path="/batches/:id/path/:lpid/report"
                          element={
                            <UserReportProvider>
                              <Report
                                lpid={lpId}
                                report={report}
                                scrpos={scrpos}
                                setLpId={setLpId}
                                navigate={navigate}
                                handleMcq={handleMcq}
                                setReport={setReport}
                                setStatus={setStatus}
                                setscrpos={setscrpos}
                                performance={performance}
                                setIsLoaded={setIsLoaded}
                                handleContent={handleContent}
                                setperformance={setperformance}
                                selectedQuestion={selectedQuestion}
                                assignQuestionToLearner={assignQuestionToLearner}
                              />
                            </UserReportProvider>
                          }
                        />
                      </Route>
                      <Route
                        path="/"
                        element={<Navigate replace to="/batches" />}
                      />
                    </Route>
                  )}

                  <Route
                    element={
                      <RequireAuth
                        allowedRoles={[
                          constants.Roles.hr,
                          constants.Roles.admin,
                          constants.Roles.trainer,
                          constants.Roles.evaluator,
                          constants.Roles.customer,
                          constants.Roles.super_admin,
                          constants.Roles.tutor,
                        ]}
                      />
                    }
                  >
                    <Route path="/company" element={<Company />} />
                    {getDataFromStorage("role") !== constants.Roles.hr &&
                      getDataFromStorage("role") !== constants.Roles.customer &&
                      getDataFromStorage("role") !==
                      constants.Roles.evaluator && (
                        <>
                          <Route
                            path="/library"
                            element={
                              <LibraryProvider>
                                <LibraryDetails
                                  que={
                                    tableShowStatus !== 1 ? quereport : querepor
                                  }
                                  setisqueReport={setisqueReport}
                                />
                              </LibraryProvider>
                            }
                          >
                            <Route
                              index
                              path=":type/shared"
                              element={<Subjects isShared={true} />}
                            />
                            <Route
                              index
                              path=":type/subjects"
                              element={<Subjects />}
                            />
                            <Route
                              path=":type/questionlist"
                              element={
                                <QuestionList
                                  isstableState={isstableState}
                                  setisqueReport={setisqueReport}
                                  selectedLibType={selectedLibType}
                                  tableShowStatus={tableShowStatus}
                                  setIsStableState={setIsStableState}
                                  stablePageforBackbtn={stablePageforBackbtn}
                                  stableTextforBackbtn={stableTextforBackbtn}
                                  stableStateforBackbtn={stableStateforBackbtn}
                                  setStableTextforBackbtn={
                                    setStableTextforBackbtn
                                  }
                                  setStablePageforBackbtn={
                                    setStablePageforBackbtn
                                  }
                                  que={
                                    tableShowStatus !== 1 ? quereport : querepor
                                  }
                                  setStableStateforBackbtn={
                                    setStableStateforBackbtn
                                  }
                                />
                              }
                            />
                          <Route
                            path=":type/cc/section"
                            element={
                              <AdminCcSection/>
                            }
                          />
                          <Route
                            path=":type/cc/section/:secid"
                            element={
                              <DndProvider backend={HTML5Backend}>
                                <AdminCcSectionQuestions />
                              </DndProvider>
                            }
                          />
                            <Route
                              path=":type/contententry"
                              element={
                                <ContentEntry
                                  selectque={selectque}
                                  quereport={quereport}
                                  isqueReport={isqueReport}
                                  setselectque={setselectque}
                                  setisqueReport={setisqueReport}
                                  tableShowStatus={tableShowStatus}
                                  selectedLibType={selectedLibType}
                                />
                              }
                            />
                            <Route
                              path=":type/contententry/:libid"
                              element={
                                <ContentEntry
                                  selectque={selectque}
                                  quereport={quereport}
                                  isqueReport={isqueReport}
                                  setselectque={setselectque}
                                  setisqueReport={setisqueReport}
                                  tableShowStatus={tableShowStatus}
                                  selectedLibType={selectedLibType}
                                />
                              }
                            />
                            <Route
                              path=":type/testlist"
                              element={
                                <TestList
                                  setselectque={setselectque}
                                  setTableShowStatus={setTableShowStatus}
                                />
                              }
                            />
                            <Route
                              path="mock/test"
                              element={
                                <MockTestList
                                  setselectque={setselectque}
                                  setTableShowStatus={setTableShowStatus}
                                  mockuse={1}
                                />
                              }
                            />
                            <Route
                              path="mock/test/create"
                              element={
                                <CreateTest
                                  setselectque={setselectque}
                                  setTableShowStatus={setTableShowStatus}
                                  mockuse={1}
                                />
                              }
                            />
                            <Route
                              path=":type/test/create"
                              element={<CreateTest />}
                            />
                            <Route
                              path=":type/test/:testid"
                              element={<CreateTest />}
                            />
                            <Route
                              path="mock/test/:testid"
                              element={<CreateTest mockuse={1} />}
                            />
                            <Route
                              path=":type/questions"
                              element={
                                <QuestionsEntry
                                  msg={msg}
                                  show={show}
                                  title={title}
                                  setMsg={setMsg}
                                  setShow={setShow}
                                  setTitle={setTitle}
                                  isLoaded={isLoaded}
                                  quereport={quereport}
                                  selectque={selectque}
                                  handleClose={handleClose}
                                  isqueReport={isqueReport}
                                  setIsLoaded={setIsLoaded}
                                  setselectque={setselectque}
                                  isstableState={isstableState}
                                  setisqueReport={setisqueReport}
                                  tableShowStatus={tableShowStatus}
                                  selectedLibType={selectedLibType}
                                  setIsStableState={setIsStableState}
                                />
                              }
                            >
                              <Route
                                path=":questionid"
                                element={
                                  <QuestionsEntry
                                    msg={msg}
                                    show={show}
                                    title={title}
                                    setMsg={setMsg}
                                    setShow={setShow}
                                    setTitle={setTitle}
                                    isLoaded={isLoaded}
                                    quereport={quereport}
                                    selectque={selectque}
                                    handleClose={handleClose}
                                    isqueReport={isqueReport}
                                    setIsLoaded={setIsLoaded}
                                    setselectque={setselectque}
                                    isstableState={isstableState}
                                    setisqueReport={setisqueReport}
                                    tableShowStatus={tableShowStatus}
                                    selectedLibType={selectedLibType}
                                    setIsStableState={setIsStableState}
                                  />
                                }
                              />
                            </Route>
                            <Route
                              path=":type/assignment"
                              element={
                                <AssignmentForm
                                  selectque={selectque}
                                  isqueReport={isqueReport}
                                  setselectque={setselectque}
                                  setisqueReport={setisqueReport}
                                />
                              }
                            >
                              <Route
                                path=":questionid"
                                element={
                                  <AssignmentForm
                                    selectque={selectque}
                                    isqueReport={isqueReport}
                                    setselectque={setselectque}
                                    setisqueReport={setisqueReport}
                                  />
                                }
                              />
                            </Route>
                          </Route>
                          <Route path="/live" element={<ZoomAdminView />} />
                        </>
                      )}

                    {getDataFromStorage("role") !== constants.Roles.customer &&
                      getDataFromStorage("role") !==
                      constants.Roles.evaluator && (
                        <>
                          <Route path="/batches" element={<Batches />} />
                        </>
                      )}
                    {getDataFromStorage("role") !== constants.Roles.evaluator && (
                      <>
                        <Route
                          path="/jobs"
                          element={
                            Number(localStorage.getItem("university_type")) ===
                              constants.ACCOUNT_TYPE.CORPORATE ? (
                              <Error403 />
                            ) : (
                              <MainPage />
                            )
                          }
                        />
                        <Route
                          path="/addjob"
                          element={
                            <JobForm
                              openForm={openJobForm}
                              setOpenForm={setOpenJobForm}
                            />
                          }
                        />
                      </>
                    )}
                    <Route path="/batches/:id/" element={<Batch />}>
                      {getDataFromStorage("role") !== constants.Roles.hr &&
                        getDataFromStorage("role") !== constants.Roles.customer &&
                        getDataFromStorage("role") !==
                        constants.Roles.evaluator && (
                          <>
                            <Route
                              element={<Settings />}
                              path="/batches/:id/settings"
                            >
                              <Route
                                index
                                path="details"
                                element={<BatchDetails />}
                              />
                              <Route path="clients" element={<Clients />} />
                              <Route path="skillmap" element={<SkillMapping />} />
                              <Route
                                path="trainers"
                                element={<BatchTrainers />}
                              />
                            </Route>
                            {/* <Route
                            path="/batches/:id/courses"
                            element={
                              <Courses
                                quereport={querepor}
                                setisqueReport={setisqueReport}
                                setTableShowStatus={setTableShowStatus}
                              />
                            }
                          /> */}
                            <Route
                              path="/batches/:id/courses/:lpid"
                              element={<Path />}
                            />
                            <Route
                              path="/batches/:id/courses/:lpid/module/:mid"
                              element={<ModuleDetails />}
                            />
                            <Route
                              element={<Attendance />}
                              path="/batches/:id/event"
                            />
                            <Route
                              element={<Attandaceonline />}
                              path="/batches/:id/event/online"
                            />
                            <Route
                              element={<Attandaceoffline />}
                              path="/batches/:id/event/offline"
                            />
                            <Route
                              element={<CreateSession />}
                              path="/batches/:id/event/add"
                            />
                            <Route
                              element={<AttendanceReport />}
                              path="/batches/:id/event/record"
                            />
                            <Route
                              element={<IssueTable />}
                              path="/batches/:id/issue"
                            />
                          </>
                        )}

                      <Route
                        path="/batches/:id/timeline"
                        element={<TableContent />}
                      />
                      <Route
                        path="/batches/:id/announcementposter"
                        element={<AdminNotices />}
                      />
                      <Route
                        path="/batches/:id/performance"
                        element={<BatchDashboard />}
                      />
                      <Route
                        index
                        path="/batches/:id/users"
                        element={
                          <UserReportProvider>
                            <UserTable />
                          </UserReportProvider>
                        }
                      />

                      <Route
                        path="/batches/:id/report"
                        element={
                          <OldReport
                            lpid={lpId}
                            report={report}
                            scrpos={scrpos}
                            setLpId={setLpId}
                            navigate={navigate}
                            handleMcq={handleMcq}
                            setReport={setReport}
                            setStatus={setStatus}
                            setscrpos={setscrpos}
                            performance={performance}
                            setIsLoaded={setIsLoaded}
                            handleContent={handleContent}
                            setperformance={setperformance}
                            selectedQuestion={selectedQuestion}
                            assignQuestionToLearner={assignQuestionToLearner}
                          />
                        }
                      />

                      <Route
                        path="/batches/:id/path/:lpid/report"
                        element={
                          <UserReportProvider>
                            <ReportPage
                              lpid={lpId}
                              report={report}
                              scrpos={scrpos}
                              setLpId={setLpId}
                              navigate={navigate}
                              handleMcq={handleMcq}
                              setReport={setReport}
                              setStatus={setStatus}
                              setscrpos={setscrpos}
                              performance={performance}
                              setIsLoaded={setIsLoaded}
                              handleContent={handleContent}
                              setperformance={setperformance}
                              selectedQuestion={selectedQuestion}
                              assignQuestionToLearner={assignQuestionToLearner}
                            />
                          </UserReportProvider>
                        }
                      />

                      <Route
                        path="/batches/:id/dashboard"
                        element={<BatchDashboardReports />}
                      />
                      <Route path="dashboard/config" element={<RightMain />} />
                    </Route>

                    {getDataFromStorage("role") !== constants.Roles.hr &&
                      getDataFromStorage("role") !== constants.Roles.customer &&
                      getDataFromStorage("role") !==
                      constants.Roles.evaluator && (
                        <>
                          {" "}
                          <Route
                            path="/learningPath"
                            element={
                              <AdminLearningPath
                                quereport={querepor}
                                setisqueReport={setisqueReport}
                                setTableShowStatus={setTableShowStatus}
                              />
                            }
                          />
                          <Route path="/learningpath/:lpid" element={<Path />} />
                          <Route
                            path="/learningpath/:lpid/module/:mid"
                            element={<ModuleDetails />}
                          />
                          {/* <Route
                        path="/mcqadmin"
                        element={<TestPage isAdmin={true} />}
                      /> */}
                          <Route
                            path="/profile/companyinfo"
                            exact
                            element={<CompanyProfile />}
                          />
                        </>
                      )}
                    {getDataFromStorage("role") !== constants.Roles.evaluator && (
                      // <Route path="/hackathons" element={Number(localStorage.getItem("university_type")) !== constants.ACCOUNT_TYPE.CORPORATE && <Hackathons />}

                      // />

                      <Route
                        path="/hackathons"
                        element={
                          Number(localStorage.getItem("university_type")) ===
                            constants.ACCOUNT_TYPE.CORPORATE ? (
                            <Error403 />
                          ) : (
                            <Hackathons />
                          )
                        }
                      />
                    )}
                    <Route
                      path="/"
                      element={<Navigate replace to="/company" />}
                    />
                  </Route>

                  <Route
                    element={
                      <RequireAuth
                        allowedRoles={[
                          constants.Roles.learner,
                          constants.Roles.parent,
                        ]}
                      />
                    }
                  >
                    <Route path="/main" element={<MenuBar />}>
                      <Route path="soa" element={<SOADashboard />} />
                      <Route path="cc" element={<CcHome />} />
                      <Route path="jobs" element={<MainPage />} />
                      <Route path="landing" element={<SOADashboard />} />
                      <Route path="hackathons" element={<Hackathons />} />
                      <Route path="noticeboard" element={<StudentNoticeBoard />} />
                      <Route
                        exact
                        path="dashboard"
                        element={
                          <UserReportProvider>
                            <Dashboard />
                          </UserReportProvider>
                        }
                      >
                        <Route
                          path="timespent"
                          element={<UserTimeSpentReport />}
                        />
                        <Route
                          path="testresults"
                          element={<UserTestResultReportTable />}
                        />
                        <Route path="learningpath" element={<LearningPath />} />
                        <Route
                          path="studentremarks"
                          element={
                            <StudentsRemarks
                              id={getDataFromStorage("learnerid")}
                              from="parentpage"
                              batch_id={localStorage.getItem("batchid")}
                            />
                          }
                        />
                      </Route>
                      <Route
                        path="mock"
                        element={
                          <MockTestPageProvider>
                            <MockTestPage />
                          </MockTestPageProvider>
                        }
                      >
                        <Route path="results" element={<MockTestResults />} />
                        <Route
                          exact
                          index
                          path="library"
                          element={<MockTestLibrary />}
                        ></Route>
                      </Route>
                      <Route
                        path="cc/section/:secid"
                        element={<CcSecQuestions />}
                      />
                      <Route
                        path="discussion"
                        element={
                          <div className="discussion">
                            <h4>Discussion Forum coming soon</h4>
                          </div>
                        }
                      />
                      <Route
                        path="interview"
                        element={
                          <MockTestPageProvider>
                            <MockTestPage />
                          </MockTestPageProvider>
                        }
                      >
                        <Route path="results" element={<MockTestResults />} />
                        <Route
                          exact
                          index
                          path="library"
                          element={<InterviewLibrary />}
                        ></Route>
                      </Route>

                      <Route
                        path="company_specific"
                        element={
                          <MockTestPageProvider>
                            <MockTestPage />
                          </MockTestPageProvider>
                        }
                      >
                        <Route path="results" element={<CompanySpecificResults />} />
                        <Route
                          exact
                          index
                          path="library"
                          element={<CompanySpecificLibrary />}
                        ></Route>
                      </Route>

                      <Route
                        path="technology_specific"
                        element={
                          <MockTestPageProvider>
                            <MockTestPage />
                          </MockTestPageProvider>
                        }
                      >
                        <Route path="results" element={<TechnologySpecificResults />} />
                        <Route
                          exact
                          index
                          path="library"
                          element={<TechnologySpecificLibrary />}
                        ></Route>
                      </Route>

                      <Route
                        path="doubts"
                        element={
                          <div className="discussion">
                            <DoubtsTable />
                          </div>
                        }
                      />
                      <Route
                        path="issue"
                        element={
                          <div className="discussion">
                            <RaisedIssueTable />
                          </div>
                        }
                      />
                    </Route>
                    <Route
                      path="/"
                      element={<Navigate replace to="/main/landing" />}
                    />
                  </Route>

                  {/* Learner Routes */}

                  <Route
                    element={
                      <RequireAuth allowedRoles={[constants.Roles.learner]} />
                    }
                  >
                    <Route path="/home" element={<LeftNavBar />} />
                    <Route path="/joblist" element={<MainPage />} />
                    <Route
                      path="/content"
                      element={
                        <ContentEntry
                          selectque={selectque}
                          quereport={quereport}
                          isqueReport={isqueReport}
                          setselectque={setselectque}
                          setisqueReport={setisqueReport}
                          tableShowStatus={tableShowStatus}
                          selectedLibType={selectedLibType}
                        />
                      }
                    />

                    <Route
                      path="/newcontent"
                      element={
                        <Content
                          lpId={lpId}
                          status={status}
                          setLpId={setLpId}
                          lpConfigId={lpConfigId}
                          contentData={contentData}
                          handleNavigate={handleNavigate}
                        />
                      }
                    />

                    <Route path="/registration" element={<RegistrationPage />} />
                    <Route
                      path="/"
                      element={<Navigate replace to="/main/landing" />}
                    />
                    <Route element={<LearningPath />} path="/learn" />
                  </Route>

                  {/* Learner Routes */}
                  <Route
                    element={
                      <RequireAuth
                        allowedRoles={[
                          "/dp",
                          constants.Roles.admin,
                          constants.Roles.learner,
                          constants.Roles.trainer,
                          constants.Roles.customer,
                          constants.Roles.super_admin,
                          constants.Roles.evaluator,
                        ]}
                      />
                    }
                  >
                    <Route path="/sql" element={<SQLPage />} />
                    <Route path="/coding" element={<CodingPage />} />
                    <Route
                      path="/ainterview"
                      element={
                        <StudentTestPageProvider>
                          <Interview />
                        </StudentTestPageProvider>
                      }
                    />
                    <Route path="/assignment" element={<RightMain />} />
                    <Route path="/instruction" element={<RightMain />} />
                    {/* <Route
                    path="/mock"
                    element={
                      <MockTestPageProvider>
                        <MockTestPage />
                      </MockTestPageProvider>
                    }
                  >
                    <Route
                      path="test"
                      element={
                        <MockTestList
                          setselectque={setselectque}
                          setTableShowStatus={setTableShowStatus}
                        />
                      }
                    />
                    <Route
                      path="learningpath"
                      element={<MockLearningPathList />}
                    />
                    <Route
                      path="create/learningpath"
                      element={<MockLearningPath />}
                    />
                  </Route> */}

                    <Route path="/dp" element={<MobileView />}>
                      <Route
                        path="instruction"
                        element={<MobileViewInstruction />}
                      />
                      <Route path="setup" element={<MobileViewSetUp />} />
                    </Route>

                    <Route
                      path="/sandpack"
                      element={
                        contentData?.template?.value === "React" ? (
                          <SandpackReactEditor
                            status={status}
                            isqueReport={false}
                            isAddSubmission={isAddSubmission}
                            selectedTemplate={contentData.template}
                            openSandpackEditor={openSandpackEditor}
                            setOpenSandpackEditor={setOpenSandpackEditor}
                            learnerId
                            libDetails={{
                              id: libId,
                              learnerId,
                              lpId: lpId,
                              lpConfigId: lpConfigId,
                              learnerNotes: learnerNotes,
                            }}
                          />
                        ) : (
                          <SandPackEditor
                            status={status}
                            isqueReport={false}
                            isAddSubmission={isAddSubmission}
                            selectedTemplate={contentData.template}
                            openSandpackEditor={openSandpackEditor}
                            setOpenSandpackEditor={setOpenSandpackEditor}
                            learnerId
                            libDetails={{
                              id: libId,
                              learnerId,
                              lpId: lpId,
                              lpConfigId: lpConfigId,
                              learnerNotes: learnerNotes,
                            }}
                          />
                        )
                      }
                    />

                    {/* Profile */}

                    <Route
                      path="/profile"
                      element={
                        <ProfileProvider>
                          <Profile />
                        </ProfileProvider>
                      }
                    >
                      <Route
                        exact
                        index
                        path="personalinfo"
                        element={
                          <PersonalInfoForm role={getDataFromStorage("role")} />
                        }
                      />
                      <Route
                        exact
                        index
                        path="parentinfo"
                        element={<ParentInfo role={getDataFromStorage("role")} />}
                      />
                      <Route
                        path="education"
                        element={
                          <EducationForm role={getDataFromStorage("role")} />
                        }
                      />
                      <Route
                        path="academic"
                        element={
                          <AcademicWork role={getDataFromStorage("role")} />
                        }
                      />
                      <Route
                        path="socialprofile"
                        element={
                          <SocialProfiles
                            role={getDataFromStorage("role")}
                            learnerId={getDataFromStorage("learnerid")}
                          />
                        }
                      />
                      <Route
                        path="viewresume"
                        element={<Resume role={getDataFromStorage("role")} />}
                      />
                      <Route
                        path="studentremarks"
                        element={
                          <StudentsRemarks
                            id={getDataFromStorage("learnerid")}
                            className="studentPage"
                          />
                        }
                      />
                    </Route>

                    {takeMcqAndDesTest && (
                      <Route
                        path="/mcq"
                        element={
                          <StudentTestPageProvider>
                            <StudentTestPage />
                          </StudentTestPageProvider>
                        }
                      />
                    )}
                  </Route>

                  {/* Dashboard */}
                  <Route
                    element={
                      <RequireAuth
                        allowedRoles={[
                          constants.Roles.hr,
                          constants.Roles.admin,
                          constants.Roles.trainer,
                          constants.Roles.super_admin,
                        ]}
                      />
                    }
                  >
                    <Route path="/dashboards" element={<DashBoardTable />} />
                    {/* <Route path="/university-dashboard" element={localStorage.getItem("university_type") != constants.ACCOUNT_TYPE.CORPORATE && (<UniversityDashboard />)} /> */}

                    <Route
                      path="/university-dashboard"
                      element={
                        Number(localStorage.getItem("university_type")) ===
                          constants.ACCOUNT_TYPE.CORPORATE ? (
                          <Error403 />
                        ) : (
                          <UniversityDashboard />
                        )
                      }
                    />
                    <Route
                      path="/dashboard"
                      element={
                        getDataFromStorage("role") == constants.Roles.hr ? (
                          <AdminDashBoard />
                        ) : (
                          <div style={{ marginTop: "50px" }}>
                            <AdminDashBoard />
                          </div>
                        )
                      }
                    />
                    <Route path="/dashboardadd" element={<DashBoardForm />} />
                    <Route
                      path="/"
                      element={<Navigate replace to="/dashboards" />}
                    />
                  </Route>

                  {/* Profiles */}
                  <Route
                    element={
                      <RequireAuth
                        allowedRoles={[
                          constants.Roles.admin,
                          constants.Roles.customer,
                          constants.Roles.super_admin,
                          constants.Roles.trainer,
                        ]}
                      />
                    }
                  >
                    <Route
                      element={
                        <UserReportProvider>
                          <Recommended />
                        </UserReportProvider>
                      }
                      path="/profiles"
                    />
                    <Route
                      path="/"
                      element={<Navigate replace to="/profiles" />}
                    />
                    {/* <Route
                      element={
                        <UserReportProvider>
                          <RecommendedTestPoints />
                        </UserReportProvider>
                      }
                      path="/profiles/testpoints"
                    /> */}

                    <Route
                      path="/profiles"
                      element={
                        Number(localStorage.getItem("university_type")) ===
                          constants.ACCOUNT_TYPE.CORPORATE ? (
                          <Error403 />
                        ) : (
                          <UserReportProvider>
                            <Recommended />
                          </UserReportProvider>
                        )
                      }
                    />
                  </Route>

                  {/* All Users */}
                  <Route
                    element={
                      <RequireAuth
                        allowedRoles={[
                          constants.Roles.hr,
                          constants.Roles.trainer,
                          constants.Roles.super_admin,
                        ]}
                      />
                    }
                  >
                    <Route path="/users" element={<UsersTableQueryProviders />} />
                  </Route>

                  <Route path="/universitysettings" element={<UniversitySettings />} />

                </Route>
              </Route>
            </Route>

            <Route path="*" element={<Error404 />} />
          </Routes>
        </div>
      </CustomView>
    </>
  );
}

export default App;
